import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { catchError, Observable, retry, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FolioUnicoRutasService {
    private apiUrl: string ='';
    private apiUrlNueva:string='';
    private apiUrlOdoo:string="";
    constructor(private _http: HttpClient) {
        this.apiUrl = environment.SUrlgApi + 'FolioUnicoRutas';
        this.apiUrlNueva = environment.sUrlGd+'folio_unico_ruta';
        this.apiUrlOdoo= environment.sUrlNode+'project/update/unique-folios';
        // this.apiUrlNueva ='https://beta.gestiondispositivos.sw-hmp.com/api/v1';
        // this.apiUrlOdoo='https://tz.pz.cdx.beta.sw-hmp.com/api/v1/cron/project/update/unique-folios';
    }

    getApiOdoo(month:number,year:number):Observable<any>{
        const valores = {
          params: new HttpParams().
            set('month',month).
            set('year',year)
        };
        
        return this._http.get<any>(this.apiUrlOdoo,valores).pipe(retry(1), catchError(this.handleError))
    }

    editFolio(data:any):Observable<any>{
        return this._http.put<any>(this.apiUrlNueva,data).pipe(retry(1), catchError(this.handleError));
    }
    
    postFolio(data:any):Observable<any>{
        return this._http.post<any>(this.apiUrlNueva,data).pipe(retry(1), catchError(this.handleError));
    }
    getListadoEstatusUnidad(): Observable<any[]> {
        return this._http
          .get<any[]>(this.apiUrl+'/getFolioUnicos')
          .pipe(retry(1), catchError(this.handleError));
      }
    getListadoDynEstatusUnidad(): Observable<any[]> {
        return this._http
          .get<any[]>(this.apiUrl+'/getdynFolioUnicos')
          .pipe(retry(1), catchError(this.handleError));
      }
    
    handleError(error: any) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(() => {
            return errorMessage;
        });
    }
}